import CurbsidePickupIndicator from 'components/CurbsidePickupIndicator/CurbsidePickupIndicator';

export default CurbsidePickupIndicator;
